import React from 'react'
import { string, func, object } from 'prop-types'
import { withContext } from '../../../utils/withContext'
import countryData from './data.json'
import styles from './CountrySelectInput.styl'
import FaAngleDown from 'react-icons/lib/fa/angle-down'

class CountrySelectInput extends React.Component {

	static propTypes = {
		className: string,
		value: string,
		context: object,
		onChange: func
	}
	constructor(props) {
		super(props)

		const countryOptions = countryData.map((ele, i) => (
			<option key={ i } value={ ele.name }>
				{ ele.name }
			</option>
		))
		this.state = {
			countryOptions
		}
	}

	handleChange(e) {
		const { onChange } = this.props
		onChange(e)
	}

	render() {
		const { className, value, context: { i18n } } = this.props
		const { countryOptions } = this.state

		return (
			<div className={ `${ styles['country-button'] } ${ className }` }>
				<select value={ value } onChange={ this.handleChange.bind(this) } style={ { opacity: 0 } }>
					<option value={ '' }>{ i18n`choose_country_label` }</option>
					{ countryOptions }
				</select>
				<span className={ styles['selection'] }>{ value || 'Escolher um pais' }<FaAngleDown className={ styles['chevron-down'] } /></span>
			</div>
		)
	}
}

export default withContext(CountrySelectInput)



// WEBPACK FOOTER //
// ./src/client/webapp/components/CountrySelectInput/CountrySelectInput.js